import { recordUserActivity } from '@/shared/api/api-client';

let stopTracking: (() => void) | null = null;
let currentCategory = 'other';

export function startUserActivityTracking(userID: string, category: string) {
  stopTracking?.();
  stopTracking = null;
  if (!userID) {
    currentCategory = 'other';
    return;
  }
  if (category !== 'other') currentCategory = category || 'other';

  let lastInteractionAt = Date.now();
  let lastSentAt = 0;
  let stopped = false;
  const send = (signal: string) => {
    if (!stopped) void recordUserActivity(signal, currentCategory).catch(() => undefined);
  };
  const markInteraction = () => {
    lastInteractionAt = Date.now();
    if (Date.now() - lastSentAt >= 60_000) {
      lastSentAt = Date.now();
      send('active');
    }
  };
  const heartbeat = () => {
    if (document.visibilityState === 'visible' && Date.now() - lastInteractionAt <= 10 * 60 * 1000) {
      send('active');
    }
  };

  send('login');
  if (currentCategory === 'status-report') send('report_open');
  send('active');
  window.addEventListener('pointerdown', markInteraction, { passive: true });
  window.addEventListener('keydown', markInteraction, { passive: true });
  window.addEventListener('focus', markInteraction, { passive: true });
  document.addEventListener('visibilitychange', heartbeat);
  const timer = window.setInterval(heartbeat, 5 * 60 * 1000);

  stopTracking = () => {
    stopped = true;
    window.clearInterval(timer);
    window.removeEventListener('pointerdown', markInteraction);
    window.removeEventListener('keydown', markInteraction);
    window.removeEventListener('focus', markInteraction);
    document.removeEventListener('visibilitychange', heartbeat);
    void recordUserActivity('logout', category).catch(() => undefined);
  };
}

export function updateUserActivityCategory(category: string) {
  const nextCategory = category || 'other';
  const changed = currentCategory !== nextCategory;
  currentCategory = nextCategory;
  if (changed && nextCategory === 'status-report' && stopTracking) void recordUserActivity('report_open', nextCategory).catch(() => undefined);
}
